/**
 * Library version
 * @public
 */
export const VERSION = "2.0.1";
